/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

import farmacovigilanciaConfigService from "../../api/atendimentos/farmacovigilanciaConfigService";

class ProgramaFarmacovigilanciaConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            erro: "",
            configuracao: { habilitado: true, preenchimento_plataforma: true, download_pdf: true },
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.programaId !== this.props.programaId) {
            this.carregar();
        }
    }

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (data && typeof data === "object") {
            const primeiroValor = Object.values(data)[0];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await farmacovigilanciaConfigService.obterConfiguracao(programaId);
            this.setState({ loading: false, configuracao: response.data?.configuracao || this.state.configuracao });
        } catch (error) {
            console.error("Erro ao carregar parametrização de Farmacovigilância:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar a parametrização."),
            });
        }
    };

    onChange = (campo) => (event) => {
        const { checked } = event.target;
        this.setState((estado) => ({ configuracao: { ...estado.configuracao, [campo]: checked } }));
    };

    salvar = async () => {
        const { programaId } = this.props;
        const { configuracao } = this.state;

        if (configuracao.habilitado && !configuracao.preenchimento_plataforma && !configuracao.download_pdf) {
            Swal.fire(
                "Atenção",
                "Habilite ao menos uma possibilidade: preenchimento pela plataforma ou download do PDF.",
                "warning"
            );
            return;
        }

        this.setState({ salvando: true });

        try {
            const response = await farmacovigilanciaConfigService.salvarConfiguracao(programaId, configuracao);
            this.setState({ salvando: false, configuracao: response.data?.configuracao || configuracao });
            Swal.fire("Sucesso", "Parametrização salva com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao salvar parametrização de Farmacovigilância:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível salvar a parametrização."), "error");
        }
    };

    render() {
        const { loading, erro, configuracao, salvando } = this.state;

        if (loading) {
            return (
                <Card className="cardDestaque mt-4">
                    <Card.Body className="text-center">
                        <Spinner animation="border" size="sm" />
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h5 className="mb-1">Parametrização da Farmacovigilância</h5>
                    <small className="text-muted d-block mb-3">
                        Define se a funcionalidade fica disponível para o cliente e de que forma o reporte pode ser feito.
                    </small>

                    {erro && <Alert variant="danger">{erro}</Alert>}

                    <Form.Check
                        type="switch"
                        id="farmaco-habilitado"
                        className="mb-3"
                        label="Farmacovigilância habilitada"
                        checked={configuracao.habilitado}
                        onChange={this.onChange("habilitado")}
                    />

                    <div className={configuracao.habilitado ? "" : "opacity-50"}>
                        <small className="text-muted d-block mb-2">Possibilidades disponíveis</small>
                        <Form.Check
                            type="checkbox"
                            id="farmaco-plataforma"
                            className="mb-2"
                            label="Preenchimento e envio do formulário diretamente pela plataforma"
                            checked={configuracao.preenchimento_plataforma}
                            disabled={!configuracao.habilitado}
                            onChange={this.onChange("preenchimento_plataforma")}
                        />
                        <Form.Check
                            type="checkbox"
                            id="farmaco-pdf"
                            label="Download do PDF para tratamento externo"
                            checked={configuracao.download_pdf}
                            disabled={!configuracao.habilitado}
                            onChange={this.onChange("download_pdf")}
                        />
                    </div>

                    <Row className="mt-4">
                        <Col className="text-end">
                            <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                                {salvando ? "Salvando..." : "Salvar parametrização"}
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default ProgramaFarmacovigilanciaConfig;
